<template>
  <VListItemGroup class="scroller huntica-nice-scroll grey lighten-5 pr-2" multiple>
    <virtual-wrapper
      v-for="item in questions"
      :key="item.id"
      :options="{ rootMargin: '400px 0px' }"
      min-height="72"
      transition="none"
    >
      <VacancySelectQuestionRow
        :question="item"
        :selected="selected"
        @selected="addQuestion"
        @unselected="removeQuestion"
      />
    </virtual-wrapper>
  </VListItemGroup>
</template>
<script>
import VirtualWrapper from '../VirtualWrapper';
import VacancySelectQuestionRow from './VacancySelectQuestionRow.vue';

export default {
  name: 'VacancyQuestionsGroup',
  components: {
    VacancySelectQuestionRow,
    VirtualWrapper,
  },
  props: {
    selected: {
      type: Array,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    addQuestion(question) {
      if (this.isQuestionSelected(question)) {
        return;
      }

      this.$emit('update', [...this.selected, question]);
    },
    removeQuestion(question) {
      this.$emit(
        'update',
        this.selected.filter((q) => q.type !== question.type || q.id !== question.id),
      );
    },
    isQuestionSelected(question) {
      return this.selected.filter((q) => q.type === question.type && q.id === question.id).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  max-height: 350px;
  @media screen and (max-width: 1024px) {
    max-height: 208px;
  }
}
</style>
